import { MockRestCall } from "@/common/api/ApiResult.model";
import { gen_id, pluck } from "@/fp";
import { RestCallsKey } from "@/mock/demo/rest.resolver";
import { BaseAppScript, TemplateVarsMap } from "../models";
import { SCRIPTS } from "./data.mock";

// @ts-ignore
const base_scripts: BaseAppScript[] = Object.values(SCRIPTS).map(
  pluck(
    "id",
    "group",
    "action",
    "type",
    "description",
    "reduce_risk",
    "friction",
    "protection_tier",
    "threats",
    "cascading_threats"
  )
);

const job_id = gen_id("job_");
const status_for_job: Record<string, number> = {};
// @ts-ignore
const calls: Record<RestCallsKey, MockRestCall> = {
  "it-scripts.scripts": {
    delay: 1000,
    payload: async (): Promise<BaseAppScript[]> => {
      return base_scripts;
    },
  },
  "it-scripts.vars-map": {
    delay: 1000,
    payload: async (): Promise<TemplateVarsMap> => {
      const { SharedState } = await import("@/common/state");
      return {
        "{~users}": [
          {
            id: "protected_accounts_info_type",
            name: "{~info_type} protected accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "ghost_accounts_info_type",
            name: "{~info_type} ghost accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "unprotected_accounts_info_type",
            name: "{~info_type} unprotected accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "non_ghost_accounts_info_type",
            name: "{~info_type} active accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "ghost_protected_accounts_info_type",
            name: "{~info_type} ghost protected accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "ghost_unprotected_accounts_info_type",
            name: "{~info_type} ghost unprotected accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "non_ghost_protected_accounts_info_type",
            name: "{~info_type} active protected accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "non_ghost_unprotected_accounts_info_type",
            name: "{~info_type} active unprotected accounts",
            with_variant: "{~info_type}",
          },
          { id: "protected_accounts_any", name: "Protected accounts" },
          {
            id: "unprotected_privilidged_accounts_any",
            name: "Unprotected data privileged  accounts",
          },
          { id: "protected_privilidged_accounts_any", name: "" },
          { id: "ghost_accounts_any", name: "Ghost accounts" },
          {
            id: "ghost_protected_privilidged_accounts_any",
            name: "Ghost protected data privileged accounts",
          },
          {
            id: "ghost_unprotected_privilidged_accounts_any",
            name: "Ghost unprotected data privileged accounts",
          },
          {
            id: "non_ghost_protected_accounts_any",
            name: "Active protected accounts",
          },
          { id: "non_ghost_protected_privilidged_accounts_any", name: "" },
          {
            id: "non_ghost_unprotected_privilidged_accounts_any",
            name: "Active unprotected data privileged accounts",
          },
          {
            id: "protected_admin_accounts_any",
            name: "Protected administrative privileged accounts",
          },
          {
            id: "unprotected_admin_accounts_any",
            name: "Unprotected administrative privileged accounts",
          },
          {
            id: "ghost_protected_admin_accounts_any",
            name: "Ghost protected administrative privileged accounts",
          },
          {
            id: "ghost_admin_accounts_any",
            name: "Ghost administrative privileged accounts",
          },
          {
            id: "non_ghost_unprotected_admin_accounts_any",
            name: "Active unprotected administrative privileged accounts",
          },
          {
            id: "non_ghost_protected_admin_accounts_any",
            name: "Active protected administrative privileged accounts",
          },
          {
            id: "unmanaged_users_v_label",
            name: "Users with unmanaged trusted with {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "trusted_users_v_label",
            name: "Users that are trusted with {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "untrusted_users_v_label",
            name: "Users that aren't trusted with {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "new_familiarity_users_v_label",
            name: "Users that only recently were exposed to {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "existing_familiarity_users_v_label",
            name: "Users that are usually exposed to {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "strong_familiarity_users_v_label",
            name: "Users with high exposure to {~v_label}",
            with_variant: "{~v_label}",
          },
        ],
        "{~negative_pam_users}": [
          {
            id: "ghost_accounts_info_type",
            name: "{~info_type} ghost accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "unprotected_accounts_info_type",
            name: "{~info_type} unprotected accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "ghost_unprotected_accounts_info_type",
            name: "{~info_type} ghost unprotected accounts",
            with_variant: "{~info_type}",
          },
          { id: "ghost_accounts_any", name: "Ghost accounts" },
          {
            id: "unprotected_admin_accounts_any",
            name: "Unprotected administrative privileged accounts",
          },
          {
            id: "ghost_admin_accounts_any",
            name: "Ghost administrative privileged accounts",
          },
        ],
        "{~negative_users_1}": [
          {
            id: "non_ghost_unprotected_privilidged_accounts_any",
            name: "Active unprotected data privileged accounts",
          },
          {
            id: "unprotected_admin_accounts_any",
            name: "Unprotected administrative privileged accounts",
          },
          {
            id: "non_ghost_unprotected_admin_accounts_any",
            name: "Active unprotected administrative privileged accounts",
          },
        ],
        "{~negative_users_info_type}": [
          {
            id: "unprotected_accounts_info_type",
            name: "unprotected accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "non_ghost_unprotected_accounts_info_type",
            name: "active unprotected accounts",
            with_variant: "{~info_type}",
          },
        ],
        "{~negative_users}": [
          {
            id: "ghost_accounts_info_type",
            name: "{~info_type} ghost accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "unprotected_accounts_info_type",
            name: "{~info_type} unprotected accounts",
            with_variant: "{~info_type}",
          },
          {
            id: "ghost_unprotected_accounts_info_type",
            name: "{~info_type} ghost unprotected accounts",
            with_variant: "{~info_type}",
          },
          { id: "ghost_accounts_any", name: "Ghost accounts" },
          {
            id: "unprotected_admin_accounts_any",
            name: "Unprotected administrative privileged accounts",
          },
          {
            id: "ghost_admin_accounts_any",
            name: "Ghost administrative privileged accounts",
          },
          {
            id: "untrusted_users_v_label",
            name: "Users that aren't trusted with {~v_label}",
            with_variant: "{~v_label}",
          },
        ],
        "{~positive_users}": [
          {
            id: "non_ghost_protected_accounts_info_type",
            name: "{~info_type} active protected accounts",
            with_variant: "{~info_type}",
          },
          { id: "protected_accounts_any", name: "Protected accounts" },
          {
            id: "non_ghost_protected_accounts_any",
            name: "Active protected accounts",
          },
          {
            id: "trusted_users_v_label",
            name: "Users that are trusted with {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "existing_familiarity_users_v_label",
            name: "Users that are usually exposed to {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "strong_familiarity_users_v_label",
            name: "Users with high exposure to {~v_label}",
            with_variant: "{~v_label}",
          },
        ],
        "{~domains}": [
          {
            id: "unmanaged_domains",
            name: "Domains with unmanaged trust to {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "trusted_domains",
            name: "Domains trusted with {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "untrusted_domains",
            name: "Domains untrusted with {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "new_familiarity_domains",
            name: "Domains that only recently were exposed to {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "existing_familiarity_domains",
            name: "Domains that are usually exposed to {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "strong_familiarity_domains",
            name: "Domains with high exposure to {~v_label}",
            with_variant: "{~v_label}",
          },
        ],
        "{~positive_domains}": [
          {
            id: "trusted_domains",
            name: "Domains trusted with {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "existing_familiarity_domains",
            name: "Domains that are usually exposed to {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "strong_familiarity_domains",
            name: "Domains with high exposure to {~v_label}",
            with_variant: "{~v_label}",
          },
        ],
        "{~negative_domains}": [
          {
            id: "untrusted_domains",
            name: "Domains untrusted with {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "new_familiarity_domains",
            name: "Domains that only recently were exposed to {~v_label}",
            with_variant: "{~v_label}",
          },
        ],
        "{~folders}": [
          {
            id: "sharePoint_new_familiarity_folders",
            name:
              "SharePoint Folders that were added with {~v_label} only recently",
            with_variant: "{~v_label}",
          },
          {
            id: "sharePoint_existing_familiarity_folders",
            name: "SharePoint Folders with {~v_label}",
            with_variant: "{~v_label}",
          },
          {
            id: "sharePoint_strong_familiarity_folders",
            name: "SharePoint Folders with many {~v_label}",
            with_variant: "{~v_label}",
          },
        ],
        "{~files}": [
          {
            id: "sharePoint",
            name: "SharePoint Files classified as {~label}",
            with_variant: "{~label}",
          },
        ],
        "{~permissions}": [
          {
            id: "internal_ghost_folders_permissions",
            name: "Folders' Ghost permissions of internal users",
          },
          {
            id: "external_ghost_folders_permissions",
            name: "Folders' Ghost permissions of external contacts",
          },
          {
            id: "internal_folders_permissions",
            name: "Folders' permissions of internal users",
          },
          {
            id: "external_folders_permissions",
            name: "Folders' permissions of external contacts",
          },
          { id: "folders_permissions", name: "Folders' permissions for all" },
          { id: "folders_mass_exposure", name: "Folders with mass exposure" },
        ],
        "{~info_type}": [
          { id: "fd6a3357-4b1f-df40-d9f5-731e35302fe5", name: "financial" },
          { id: "e34ebd2f-cd96-22ac-3059-952a7fe01e54", name: "legal" },
          { id: "707babad-231f-82bb-014c-8506d3dc784e", name: "hr" },
          { id: "e2bd11ab-9869-5adc-f11c-7d05c7c6fc2b", name: "business" },
          { id: "2ef1d9da-0ad7-450e-4b09-efd43581ce78", name: "governance" },
          { id: "a9383d32-7694-4d84-b37c-79afb945505b", name: "personal" },
          { id: "d5f24583-7595-6d41-0760-a5d11b8be7cf", name: "other" },
        ],
        "{~v_label}": [
          {
            id: "341ac550-85ca-484a-a3e0-e5139cb81269",
            name: "Confidential Personal Information",
          },
          {
            id: "7ae67ea0-9f1f-4bc5-a0ac-55052074a985",
            name: "Personal Identifiable Information",
          },
          {
            id: "e389a0fd-8739-41c5-afa7-aa71780638cb",
            name: "Personal Information",
          },
          {
            id: "16e67a29-ffc2-4590-bad9-18687431b684",
            name: "Sensitive Personal Information",
          },
          {
            id: "d6cf4a16-ae19-44a2-9504-0403d5596f8a",
            name: "Medium+ sensitivity Other Information",
          },
          {
            id: "c8b78f96-8644-40bd-b65e-86b26cd3a891",
            name: "Highly sensitive Other Information",
          },
          {
            id: "666c2fd5-519d-435c-b757-5a1dbc6d42af",
            name: "Low+ sensitivity Other Information",
          },
          {
            id: "9ecc7f8c-fc65-4365-948a-ca98301c0eed",
            name: "Medium+ sensitivity HR Information",
          },
          {
            id: "c4e62d61-ffc3-43c4-a13b-eba4cd4f8c15",
            name: "Non-sensitive Other Information",
          },
          {
            id: "752327d9-303d-4825-84ee-df36d0e8aec7",
            name: "Highly sensitive HR Information",
          },
          {
            id: "d9fe0aba-6b36-4ac5-8f58-4f5d3b03a701",
            name: "Highly sensitive Financial Information",
          },
          {
            id: "fe71b407-0864-4c40-afb5-16bf6c55ca65",
            name: "Low+ sensitivity HR Information",
          },
          {
            id: "0ba86da4-b8b4-4fdf-ac94-9693264ac32c",
            name: "Medium+ sensitivity Financial Information",
          },
          {
            id: "94b1c3ed-b004-4698-b229-bfd1dfa6666e",
            name: "Low+ sensitivity Financial information",
          },
          {
            id: "b87beca9-4755-4253-9f59-f596f7d47188",
            name: "Non-sensitive Financial Information",
          },
          {
            id: "36382843-2b95-470c-a2a6-f2bf0dcabafe",
            name: "Medium+ sensitivity Legal Information",
          },
          {
            id: "aef93fc3-db19-4474-a298-b5d96f351e55",
            name: "Non-sensitive HR Information",
          },
          {
            id: "f7577299-754a-4570-9e8f-b43667fe32a4",
            name: "Highly sensitive Legal Information",
          },
          {
            id: "03f463d0-0aa8-4e11-b975-e663307cdb1e",
            name: "Low+ sensitivity Legal Information",
          },
          {
            id: "635c9b13-7f5f-4da2-afb3-f500f8f78666",
            name: "Medium+ sensitivity Governance Information",
          },
          {
            id: "867b0f58-9cbc-4fa2-82dc-d6230f6c0471",
            name: "Non-sensitive Legal Information",
          },
          {
            id: "18519912-1c7e-441a-bebf-9f68afcbff03",
            name: "Highly sensitive Governance Information",
          },
          {
            id: "7e9cbb81-6906-4f6e-9b02-50c0f9e5912a",
            name: "Non-sensitive Governance Information",
          },
          {
            id: "ca6efcc7-1134-4bc1-a0f6-0ea8efd5d247",
            name: "Low+ sensitivity Governance Information",
          },
          {
            id: "762dc67d-cd62-46a4-9f07-af3603a9a030",
            name: "Highly sensitive Business Information",
          },
          {
            id: "45c9c54d-eb9b-4c6d-a1d7-efdf39cb6e8c",
            name: "Medium+ sensitivity Business information",
          },
          {
            id: "e5d18fd1-ade2-45c0-b5a0-40874bb8d6c3",
            name: "Low+ sensitivity Business Information",
          },
          {
            id: "5c077ac5-4da6-4801-861b-5cc98530d093",
            name: "Non-sensitive Business Information",
          },
        ],
      };
    },
  },
  "it-scripts.full-script": {
    delay: 100,
    payload: async (script_id: string) => {
      return SCRIPTS[script_id];
    },
  },
  "it-scripts.get-entities": {
    delay: 200,
    payload: async () => {
      const id = job_id();
      status_for_job[id] = 0;
      return { job_ids: [id] };
    },
  },

  "it-scripts.get-entities-job-status": {
    delay: 200,
    payload: async (job_id: string) => {
      status_for_job[job_id]++;
      const status = status_for_job[job_id] >= 2 ? "done" : "in-progress";
      return { status };
    },
  },
};

// @ts-ignore
window.inject_mock_api(calls);
